import React from 'react';
import 'bulma/css/bulma.css';
import './styles/app.css';
import Providers from './contexts/Providers';

function App() {
  return <>
    <Providers />
  </>
}

export default App;
